import { Card, Grid } from "@mui/material";

function AboutCard({ card, index }) {
  return (
    <Grid item xs={12} sm={6} md={3}>
      <Card className="about_card">

        <div className="about_card_number">
          0{index + 1}
        </div>

        <div className="card_icon">
          {card.icon}
        </div>

        <div className="card_title">
          <h3>{card.title}</h3>
          <span>{card.subtitle}</span>
        </div>

        <p className="card_body">
          {card.text}
        </p>

        <div className="card_arrow">
          →
        </div>

      </Card>
    </Grid>
  );
}

export default AboutCard;
